import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { MockupCrop } from '../MockupCrop';
import { Accent, SectionHeading } from './SectionHeading';
import { bonusIncludes, coreIncludes } from '../../data/content';
import { MOCKUP_URL, bonusesBand, volumesBand } from '../../data/images';

/** Section 9 — everything you get. */
export function LibrarySection() {
  return <section aria-labelledby="library-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-143" data-mp="1ahowodhpoidv">
      <div className="mx-auto max-w-6xl" data-id="element-144" data-mp="1f9p56ubukjm2">
        <SectionHeading id="library-heading" eyebrow="Everything You Get" title={<>
              One System. <Accent data-id="element-146" data-mp="16fk7ps27k9xk">An Entire Makeup Education Toolkit.</Accent>
            </>} data-id="element-145" data-mp="1farwh3d30o2i" />

        <img src={MOCKUP_URL} alt="Everything included in Makeup Instructor Ready — 6 core volumes and 5 extra bonuses" width={1536} height={1024} loading="lazy" decoding="async" className="mt-12 block w-full rounded-[18px] shadow-[0_30px_60px_-36px_rgba(59,27,87,0.5)] md:hidden" data-id="element-147" data-mp="rit579x8mi3q" />

        <div className="mt-12 hidden items-end gap-6 md:grid md:grid-cols-[1.75fr_1fr]" data-id="element-148" data-mp="3dcnf3w8cy0q1">
          <figure className="rounded-[24px] bg-white p-4 shadow-[0_50px_100px_-50px_rgba(59,27,87,0.5)]" data-id="element-149" data-mp="3r7y6v0rb25q6">
            <MockupCrop crop={volumesBand} alt="The 6 core professional volumes" className="rounded-[16px]" data-id="element-150" data-mp="3n6mg2rwp3ege" />
            <figcaption className="mt-4 text-center font-body text-[12px] font-bold uppercase tracking-[0.18em] text-brand-plum" data-id="element-151" data-mp="2ujrz44z36x7o">
              6 Core Professional Volumes
            </figcaption>
          </figure>
          <figure className="rounded-[18px] bg-white/70 p-3" data-id="element-152" data-mp="33jy75bc0n4zg">
            <MockupCrop crop={bonusesBand} alt="The 5 extra bonus resources" className="rounded-[12px]" data-id="element-153" data-mp="33iddrp1fts36" />
            <figcaption className="mt-3 text-center font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-charcoal/55" data-id="element-154" data-mp="2fsj0x7h4c3ix">
              + 5 Extra Bonuses
            </figcaption>
          </figure>
        </div>

        <div className="mx-auto mt-12 grid max-w-4xl gap-8 sm:grid-cols-2 sm:gap-12" data-id="element-155" data-mp="jr8vzakxhnf3">
          <div data-id="element-156" data-mp="oiqy41yotu1n">
            <p className="font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-plum" data-id="element-157" data-mp="ohxqkyrwn0ig">The core system</p>
            <ul className="mt-4 space-y-3" role="list" data-id="element-158" data-mp="tg8z966gr4z3">
              {coreIncludes.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] font-medium leading-snug text-brand-charcoal" data-id="element-159" data-mp="3s0hg3tj77s9k">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-160" data-mp="uzba4fitym4" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div data-id="element-161" data-mp="aopyl5zww308">
            <p className="font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-charcoal/50" data-id="element-162" data-mp="1h7emi6eqgzjf">
              Extra bonuses
            </p>
            <ul className="mt-4 space-y-3" role="list" data-id="element-163" data-mp="1m4el5w99700i">
              {bonusIncludes.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] leading-snug text-brand-charcoal/80" data-id="element-164" data-mp="36nh1h43zuvul">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-165" data-mp="31rjkcvkwplgr" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-12 max-w-3xl border-t border-dashed border-brand-charcoal/20 pt-10 text-center" data-id="element-166" data-mp="2n0sqlhzr8cb0">
          <p className="font-body text-[12px] font-semibold uppercase tracking-[0.18em] text-brand-charcoal/55" data-id="element-167" data-mp="2ixmlwesait6n">
            Total package: 11 professional digital resources
          </p>
          <h3 className="mt-3 font-display text-[1.9rem] font-bold leading-[1.1] text-brand-charcoal sm:text-[2.4rem]" data-id="element-168" data-mp="291b8tmkvlzb5">
            Get Everything Today for Only <Accent data-id="element-169" data-mp="c65beuqydaz5">$27</Accent>
          </h3>
          <CtaBlock label="Yes — I Want Makeup Instructor Ready" note="Instant Digital Access • One-Time Payment • No Subscription" className="mt-8" data-id="element-170" data-mp="78veku18hx1a" />
        </div>
      </div>
    </section>;
}